// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dropdown-container[data-v-3362e6a2] {
	position: relative;
	display: inline-block;
	background-color: #444;
	border-radius: 8px 8px 0 0;
	box-shadow: 0 2px 4px 0 #444;
	min-width: var(--min-width);

	--min-width: 12em;
	--unrolled-height: 500px;
}
.handle[data-v-3362e6a2] {
	margin: 0.25em 0.5em;
	text-align: center;
}
.handle span[data-v-3362e6a2] {
	margin: 0 0.25em;
}
.dropdown[data-v-3362e6a2] {
	position: absolute;
	top: 100%;
	z-index: 1;
	background-color: #444;
	width: 100%;
	box-sizing: border-box;
	border-radius: 0 0 8px 8px;
	max-height: 0;
	overflow: hidden;
	transition: all 0.2s ease-in-out;
	text-align: center;
}
.handle[data-v-3362e6a2]::after {
	position: absolute;
	font-family: "Mini Font Awesome 5 Free";
	font-weight: 900;
	content: "\\f0d7";
	right: 5px;
	bottom: -7px;
	transition: transform 0.2s ease;
}
.forced-open .handle[data-v-3362e6a2]::after {
	transform: rotate(180deg);
}
.forced-open .dropdown[data-v-3362e6a2] {
	max-height: var(--unrolled-height);
	box-shadow: 0 8px 8px 1px rgba(0, 0, 0, 0.5);
	z-index: 1;
}
@media (any-hover: hover) {
.dropdown-container:hover .handle[data-v-3362e6a2]::after {
		transform: rotate(180deg);
}
.dropdown-container:hover .dropdown[data-v-3362e6a2] {
		max-height: var(--unrolled-height);
		box-shadow: 0 8px 8px 1px rgba(0, 0, 0, 0.5);
		z-index: 1;
}
}
.content[data-v-3362e6a2] {
	margin: 0.5em;
	display: flex;
	flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./client/src/components/Dropdown.vue"],"names":[],"mappings":";AAgEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,0BAA0B;CAC1B,4BAA4B;CAC5B,2BAA2B;;CAE3B,iBAAiB;CACjB,wBAAwB;AACzB;AAEA;CACC,oBAAoB;CACpB,kBAAkB;AACnB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,sBAAsB;CACtB,WAAW;CACX,sBAAsB;CACtB,0BAA0B;CAC1B,aAAa;CACb,gBAAgB;CAChB,gCAAgC;CAChC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,uCAAuC;CACvC,gBAAgB;CAChB,gBAAgB;CAChB,UAAU;CACV,YAAY;CACZ,+BAA+B;AAChC;AAEA;CACC,yBAAyB;AAC1B;AAEA;CACC,kCAAkC;CAClC,4CAA4C;CAC5C,UAAU;AACX;AAEA;AACC;EACC,yBAAyB;AAC1B;AACA;EACC,kCAAkC;EAClC,4CAA4C;EAC5C,UAAU;AACX;AACD;AAEA;CACC,aAAa;CACb,aAAa;CACb,sBAAsB;AACvB","sourcesContent":["<template>\n\t<span class=\"dropdown-container\" @mouseenter=\"updateHeight\" :class=\"{ 'forced-open': forcedOpen }\" ref=\"element\">\n\t\t<div class=\"handle\" @pointerdown=\"toggleKeepOpen\"><slot name=\"handle\"></slot></div>\n\t\t<div class=\"dropdown\">\n\t\t\t<div class=\"content\" ref=\"content\">\n\t\t\t\t<slot name=\"dropdown\"></slot>\n\t\t\t</div>\n\t\t</div>\n\t</span>\n</template>\n\n<script setup lang=\"ts\">\nimport { ref, useTemplateRef, onMounted } from \"vue\";\n\ndefineExpose({\n\tupdateHeight,\n});\n\nconst props = withDefaults(defineProps<{ minwidth?: string }>(), {\n\tminwidth: \"12em\",\n});\n\nconst forcedOpen = ref(false);\nconst element = useTemplateRef(\"element\");\nconst content = useTemplateRef(\"content\");\n\nonMounted(() => {\n\tupdateHeight();\n});\n\nfunction updateHeight() {\n\telement.value?.setAttribute(\n\t\t\"style\",\n\t\t`--unrolled-height: calc(1em + ${content.value?.clientHeight}px); --min-width: ${props.minwidth}`\n\t);\n}\n\nfunction toggleKeepOpen() {\n\tsetKeepOpen(!forcedOpen.value);\n}\n\nfunction setKeepOpen(open: boolean) {\n\tif (forcedOpen.value === open) return;\n\tforcedOpen.value = open;\n\tif (forcedOpen.value) {\n\t\telement.value?.addEventListener(\"pointerdown\", stopPropagation);\n\t\tdocument.addEventListener(\"pointerdown\", onOutsideClick, { once: true });\n\t} else {\n\t\telement.value?.removeEventListener(\"pointerdown\", stopPropagation);\n\t\tdocument.removeEventListener(\"pointerdown\", onOutsideClick);\n\t}\n\tupdateHeight();\n}\n\nfunction onOutsideClick() {\n\tsetKeepOpen(false);\n}\n\nfunction stopPropagation(e: Event) {\n\te.stopPropagation();\n}\n</script>\n\n<style scoped>\n.dropdown-container {\n\tposition: relative;\n\tdisplay: inline-block;\n\tbackground-color: #444;\n\tborder-radius: 8px 8px 0 0;\n\tbox-shadow: 0 2px 4px 0 #444;\n\tmin-width: var(--min-width);\n\n\t--min-width: 12em;\n\t--unrolled-height: 500px;\n}\n\n.handle {\n\tmargin: 0.25em 0.5em;\n\ttext-align: center;\n}\n\n.handle span {\n\tmargin: 0 0.25em;\n}\n\n.dropdown {\n\tposition: absolute;\n\ttop: 100%;\n\tz-index: 1;\n\tbackground-color: #444;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tborder-radius: 0 0 8px 8px;\n\tmax-height: 0;\n\toverflow: hidden;\n\ttransition: all 0.2s ease-in-out;\n\ttext-align: center;\n}\n\n.handle::after {\n\tposition: absolute;\n\tfont-family: \"Mini Font Awesome 5 Free\";\n\tfont-weight: 900;\n\tcontent: \"\\f0d7\";\n\tright: 5px;\n\tbottom: -7px;\n\ttransition: transform 0.2s ease;\n}\n\n.forced-open .handle::after {\n\ttransform: rotate(180deg);\n}\n\n.forced-open .dropdown {\n\tmax-height: var(--unrolled-height);\n\tbox-shadow: 0 8px 8px 1px rgba(0, 0, 0, 0.5);\n\tz-index: 1;\n}\n\n@media (any-hover: hover) {\n\t.dropdown-container:hover .handle::after {\n\t\ttransform: rotate(180deg);\n\t}\n\t.dropdown-container:hover .dropdown {\n\t\tmax-height: var(--unrolled-height);\n\t\tbox-shadow: 0 8px 8px 1px rgba(0, 0, 0, 0.5);\n\t\tz-index: 1;\n\t}\n}\n\n.content {\n\tmargin: 0.5em;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n</style>\n<style>\n.header {\n\tfont-variant: small-caps;\n\tfont-size: 0.75em;\n\tmargin: 0 0 0 0.25rem;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
